module.exports = __webpack_public_path__ + "static/media/HomeCardApartment.84816a38.png";